import { planTypes, BASE_PLAN_SUB_TYPES, PBX_CATEGORYS, PlanModelInfo } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import _ from 'lodash';
import { planUnitMap } from "@/common/product-unit";

export default (raw) => {
  const path = `zoomone.zoom-one-biz-plus`;
  const plans = _.get(raw, path, []);
  return plans.reduce((acc, x) => {
    const category = x.category_code;
    const parentCategory = x.parent_category;

    const pbxCategory = _.chain(category)
      .upperCase()
      .replace(_.upperCase(parentCategory), '')
      .value();

    const plan = {
      type: planTypes.ZOOM_ONE_BUNDLE,
      sub_type: BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
      zoomMeetingCategory: BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
      category,
      pbxCategory,
      plan_code: x.plan_code,
      plan_type: x.plan_type,
      amount: x.amount,
      region: x.region,
      billing_cycle: x.billing_cycle,
      parent_category: parentCategory,
      cartInfo: getCartInfo(),
      supportCoupon: true,
      dependBasePlanTypeList: [],
      typeNameKey: 'billing.planform.title.zoom_one_biz_plus',
      planNameKey: 'billing.planform.title.zoom_one_biz_plus',
      parentPlanNameKey: 'Zoom One',
      defaultPbxBase: PBX_CATEGORYS.ZVP,
      unit: window.$context?.is?.modalDelta ? planUnitMap.license : planUnitMap.user,
      planModel: PlanModelInfo.license
    };
    return [...acc, plan];
  }, []);
};
